<template>
  <div>
    <transition name="dimmer">
      <div v-if="isContactModalOpen" class="dimmer" />
    </transition>
    <transition name="modal">
      <div v-if="isContactModalOpen" class="modal-ctn">
        <div class="modal">
          <div class="modal-header">
            <div class="modal-header__title">
              Contato
            </div>
            <btn class="modal-header__close-btn" @click="closeContactModal">
              <div />
              <div />
            </btn>
          </div>
          <validation-observer ref="observer" v-slot="{ handleSubmit }">
            <form class="contact-form" @submit.prevent="handleSubmit(validateForm)">
              <div>
                <div class="sm-l:hidden md:hidden">
                  <div class="row-wrapper">
                    <p class="static-text">
                      Olá, meu nome é
                    </p>
                    <validation-provider v-slot="{ errors }" rules="required" slim>
                      <contact-input
                        v-model="contact.name"
                        class="w-full mr-1"
                        :error="!!errors.length"
                      />
                    </validation-provider>
                    <div class="static-text">
                      ,
                    </div>
                  </div>
                  <div class="row-wrapper">
                    <p class="static-text mr-1">
                      meu e-mail é
                    </p>
                    <validation-provider v-slot="{ errors }" rules="required|email" slim>
                      <contact-input
                        v-model="contact.email"
                        class="w-full mr-1"
                        :error="!!errors.length"
                      />
                    </validation-provider>
                  </div>
                  <div class="row-wrapper">
                    <p class="static-text">
                      e gostaria de conversar sobre
                    </p>
                  </div>
                  <div class="row-wrapper">
                    <validation-provider v-slot="{ errors }" rules="required" slim>
                      <contact-input
                        v-model="contact.subject"
                        class="w-full mr-1"
                        name="subject"
                        :error="!!errors.length"
                      />
                    </validation-provider>
                    <p class="static-text static-text--period">
                      .
                    </p>
                  </div>
                </div>
                <div class="hidden md:block xxl:hidden">
                  <div class="row-wrapper">
                    <p class="static-text">
                      Olá, meu nome é
                    </p>
                    <validation-provider v-slot="{ errors }" rules="required" slim>
                      <contact-input
                        v-model="contact.name"
                        class="flex-no-shrink w-48 md:w-40 mr-1"
                        :error="!!errors.length"
                      />
                    </validation-provider>
                    <p class="static-text">
                      , meu e-mail é
                    </p>
                  </div>
                  <div class="row-wrapper">
                    <validation-provider v-slot="{ errors }" rules="required" slim>
                      <contact-input
                        v-model="contact.email"
                        class="w-full mr-1"
                        :error="!!errors.length"
                      />
                    </validation-provider>
                    <p class="static-text">
                      e gostaria de conversar sobre
                    </p>
                  </div>
                  <div class="row-wrapper">
                    <validation-provider v-slot="{ errors }" rules="required" slim>
                      <contact-input
                        v-model="contact.subject"
                        class="w-full mr-1"
                        name="subject"
                        :error="!!errors.length"
                      />
                    </validation-provider>
                    <p class="static-text static-text--period">
                      .
                    </p>
                  </div>
                </div>
                <div class="hidden sm-l:block xxl:block">
                  <div class="row-wrapper">
                    <p class="static-text">
                      Olá, meu nome é
                    </p>
                    <validation-provider v-slot="{ errors }" rules="required" slim>
                      <contact-input
                        v-model="contact.name"
                        class="w-full xxl:flex-no-shrink xxl:w-48 xxxl:w-48 mr-1"
                        :error="!!errors.length"
                      />
                    </validation-provider>
                    <p class="static-text">
                      , meu e-mail é
                    </p>
                    <validation-provider v-slot="{ errors }" rules="required" slim>
                      <contact-input
                        v-model="contact.email"
                        class="w-full"
                        :error="!!errors.length"
                      />
                    </validation-provider>
                  </div>
                  <div class="row-wrapper">
                    <p class="static-text">
                      e gostaria de conversar sobre
                    </p>
                    <validation-provider v-slot="{ errors }" rules="required" slim>
                      <contact-input
                        v-model="contact.subject"
                        class="w-full xxxl:w-128 mr-1"
                        name="subject"
                        :error="!!errors.length"
                      />
                    </validation-provider>
                    <p class="static-text static-text--period">
                      .
                    </p>
                  </div>
                </div>
                <validation-provider v-slot="{ errors }" rules="required" slim>
                  <div class="flex flex-col mt-3 xxl:mt-4">
                    <label
                      for="message"
                      class="textarea-label"
                      :class="{'textarea-label--error' : !!errors.length}"
                    >
                      Mensagem
                    </label>
                    <textarea
                      id="message"
                      v-model="contact.message"
                      class="textarea"
                      :class="{'textarea--error' : !!errors.length}"
                      @mouseenter="$store.dispatch($CHANGE_CURSOR_STATE, 'text')"
                      @mouseleave="$store.dispatch($CHANGE_CURSOR_STATE, 'default')"
                    />
                  </div>
                </validation-provider>
              </div>
              <div class="modal-footer">
                <div v-show="isSendingEmail" class="loading-spinner" />
                <btn type="submit" :class="{'pointer-events-none' : isSendingEmail}">
                  <span class="action-btn">
                    Enviar
                  </span>
                </btn>
              </div>
            </form>
          </validation-observer>
          <div class="contact-success" :class="{'contact-success--visible' : isSuccessMessageVisible}">
            <div class="contact-success__bg" :class="{'contact-success__bg--visible' : isSuccessMessageVisible}" />
            <div class="contact-success__content">
              <div class="contact-success-text" :class="{'contact-success-text--visible' : isSuccessMessageVisible}">
                <p>Mensagem enviada com sucesso.</p>
                <p class="text-xl mt-1">
                  Obrigado pelo contato.
                </p>
              </div>
              <div class="close-btn">
                <div class="close-btn__border" :class="{'close-btn__border--visible' : isSuccessMessageVisible}" />
                <div class="close-btn__button" :class="{'close-btn__button--visible' : isSuccessMessageVisible}">
                  <btn @click="closeContactModal(true)">
                    <span class="action-btn">
                      Fechar
                    </span>
                  </btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ContactInput from '@/components/contact-input'
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

const MODAL_TRANSITION_TIME = 300

export default {
  name: 'Contact',
  components: {
    ContactInput,
    ValidationProvider,
    ValidationObserver
  },
  data () {
    return {
      isSuccessMessageVisible: false,
      isSendingEmail: false,
      contact: {
        name: '',
        email: '',
        subject: '',
        message: ''
      }
    }
  },
  computed: {
    ...mapState(['isContactModalOpen', 'vHeight'])
  },
  methods: {
    async closeContactModal (shouldResetForm) {
      if (shouldResetForm) {
        this.contact = {
          name: '',
          email: '',
          subject: '',
          message: ''
        }
        await this.$nextTick()
        this.$refs.observer.reset()
        this.$store.dispatch(this.$SET_TOGGLE_CONTACT_MODAL_OPEN)
        setTimeout(() => { this.isSuccessMessageVisible = false }, MODAL_TRANSITION_TIME)
      } else this.$store.dispatch(this.$SET_TOGGLE_CONTACT_MODAL_OPEN)
    },
    async validateForm () {
      try {
        this.isSendingEmail = true
        const templateParams = {
          name: this.contact.name,
          from: this.contact.email,
          subject: this.contact.subject,
          message: this.contact.message
        }
        // eslint-disable-next-line no-undef
        await emailjs.send('contact', 'site_portfolio', templateParams)
        this.isSuccessMessageVisible = true
      } catch (e) {
        alert('Ocorreu um erro ao enviar sua mensagem, mas você pode enviar um email para lelukass@gmail.com. Desculpe pelo ocorrido.')
      } finally {
        this.isSendingEmail = false
      }
    }
  },
  watch: {
    isContactModalOpen (isOpen) {
      if (isOpen) {
        document.body.onkeyup = e => {
          if (e.code === 'Escape') this.closeContactModal()
        }
      } else document.body.onkeyup = undefined
    }
  }
}
</script>

<style scoped lang="sass">
  @tailwind utilities

  $modal-border-width: 0.625rem
  $modal-header-height: 3rem //4rem
  $modal-header-bottom-margin: 2rem
  $success-bg-transition-time: .6s

  .dimmer
    @apply fixed z-50 pin-t pin-l font-sans h-full
    width: 110vw
    $stripe-color: rgba(70, 70, 70, 0.6)
    $background: rgba(96, 96, 96, 0.3)
    $stripe-width: 5px
    $stripes-gap: 10px
    background-image: repeating-linear-gradient(to right, $stripe-color, $stripe-color $stripe-width, $background $stripe-width, $background $stripes-gap)
    background-size: 100vw 100vh

  .modal-ctn
    @apply fixed z-50 pin-t pin-l flex items-center justify-center font-sans w-full h-full

  .modal
    @apply relative border-black bg-white h-4/5
    width: 95%
    border-width: $modal-border-width
    padding: $modal-border-width
    @screen sm-l
      @apply h-full
      width: 90%
    @screen md
      width: 90%
    @screen lg
      @apply w-3/4
    @screen xl
      @apply w-2/3
      padding: 1rem

  .modal-header
    @apply flex items-center justify-between
    height: $modal-header-height
    margin-bottom: $modal-header-bottom-margin
    &__title
      @apply text-3xl
      @screen xl
        @apply text-4xl
      @screen xxl
        @apply text-5xl
    &__close-btn
      @apply relative bg-black
      height: $modal-header-height
      width: $modal-header-height
      div
        @apply absolute half-t half-l w-4/5 h-2 bg-white
        &:nth-child(1)
          transform: translate(-50%, -50%) rotate(45deg)
        &:nth-child(2)
          transform: translate(-50%, -50%) rotate(-45deg)

  .contact-form
    @apply flex flex-col justify-between pr-2
    height: calc(100% - #{$modal-header-height + $modal-header-bottom-margin})
    overflow-y: auto

  .modal-footer
    @apply relative flex items-center justify-end mt-4

  .textarea-label
    @apply text-lg font-bold mb-2
    transition: all .2s
    &--error
      @apply text-red

  .textarea
    @apply font-light italic text-xl leading-tight border-3 border-black h-32 w-full
    resize: none
    outline: none
    transition: all .2s
    cursor: none
    @screen xxl
      @apply w-5/6 h-64
    &--error
      @apply border-red

  .row-wrapper
    @apply flex items-center mb-1

  .static-text
    @apply flex-no-shrink inline-block text-xl mr-1
    line-height: 1
    @screen md
      @apply text-3xl
    @screen xxxl
      @apply text-4xl
    &--no-margin
      @apply m-0
    &--period
      transform: translateY(4px)

  .action-btn
    @apply inline-block bg-black text-white text-3xl px-2 py-1

  .contact-success
    @apply absolute pin-t pin-l flex items-center justify-center opacity-0 pointer-events-none w-full h-full
    &--visible
      @apply opacity-100 pointer-events-auto
    &__bg
      @apply absolute pin-t pin-l w-full h-full bg-black
      transform-origin: center bottom
      transition: transform $success-bg-transition-time cubic-bezier(.09,.64,.63,.95)
      transform: scaleY(0)
      @screen sm-l
        transform-origin: left center
        transform: scaleX(0)
      &--visible
        transform: none
    &__content
      @apply relative z-10 flex flex-col items-center text-2xl text-white

    .contact-success-text
      @apply text-center
      & > *
        @apply opacity-0
        transition: opacity $success-bg-transition-time / 3 $success-bg-transition-time / 3
      &--visible
        & > *
          @apply opacity-100

  .close-btn
    @apply relative inline-flex items-center justify-center overflow-hidden mt-3
    width: 9rem
    height: 4rem
    &__border
      @apply absolute pin-t pin-l bg-white w-full h-full
      transform-origin: center bottom
      transition: transform $success-bg-transition-time / 1.8 $success-bg-transition-time / 2 cubic-bezier(.09,.64,.63,.95)
      transform: scaleY(0)
      &--visible
        transform: none
    &__button
      @apply relative z-10 flex items-center justify-center w-full h-full
      transition: transform $success-bg-transition-time / 1.3 $success-bg-transition-time / 1.4 cubic-bezier(.01,.65,.72,1.01)
      transform: translateY(100%)
      &--visible
        transform: none

  .loading-spinner
    @apply absolute rounded-full border-black border-3 w-8 h-8 mr-3
    top: calc(50% - 1rem)
    right: 8rem
    border-bottom-color: transparent
    animation: rotate 1s infinite

  .dimmer
    &-enter, &-leave-to
      @apply opacity-0
      transform: translateX(-5%)
      @screen sm-l
        transform: translateX(-2%)
    &-enter-to, &-leave
      @apply opacity-100
      transform: translateX(0)
    &-enter-active
      transition: transform .5s .2s cubic-bezier(.14,.64,.63,1.02), opacity .5s .2s
      @screen md
        transition: transform .6s .3s cubic-bezier(.14,.64,.63,1.02), opacity .6s .3s
    &-leave-active
      transition: transform .5s cubic-bezier(.14,.64,.63,1.02), opacity .5s
      @screen md
        transition: transform .6s cubic-bezier(.14,.64,.63,1.02), opacity .6s

  .modal
    &-enter, &-leave-to
      transform: translateY(100%)
    &-enter-to, &-leave
      transform: translateY(0)
    &-enter-active, &-leave-active
      transition-property: transform
      transition-timing-function: cubic-bezier(.14,.64,.63,1.02)
      transition-duration: 0.5s
      @screen sm-l
        transition-duration: 0.4s
      @screen md
        transition-duration: 0.6s

  @keyframes rotate
    0%
      transform: rotate(0deg)
    100%
      transform: rotate(360deg)
</style>
